export function SanitizeClientDiagnosticText(
    value: string,
    maxLength = 4000
) {
    return RedactSensitiveText(value).slice(0, maxLength);
}

export function SanitizeDiagnosticValue(value: unknown, key?: string): unknown {
    if (key && IsSensitiveKey(key)) {
        return "[redacted]";
    }

    if (typeof value === "string") {
        return SanitizeClientDiagnosticText(value);
    }

    if (Array.isArray(value)) {
        return value.map((item) => SanitizeDiagnosticValue(item));
    }

    if (value && typeof value === "object") {
        return Object.fromEntries(
            Object.entries(value).map(([entryKey, entryValue]) => [
                entryKey,
                SanitizeDiagnosticValue(entryValue, entryKey),
            ])
        );
    }

    return value;
}

function IsSensitiveKey(key: string) {
    return /^(authorization|cookie|cookies|password|passkey|secret|token|credential|requestBody|responseBody|body|quotes?|text)$/i.test(
        key
    );
}

function RedactSensitiveText(value: string) {
    return value
        .replace(/\bBearer\s+[^\s]+/gi, "Bearer [redacted]")
        .replace(
            /\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g,
            "[redacted jwt]"
        )
        .replace(
            /\b(?:access|refresh)=[^;\s]+/gi,
            (match) => `${match.split("=")[0]}=[redacted]`
        )
        .replace(
            /("(?:authorization|cookie|cookies|password|passkey|secret|token|credential|requestBody|responseBody|body|quotes?|text)"\s*:\s*")[^"]*(")/gi,
            "$1[redacted]$2"
        );
}
